import * as React from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';

export interface IHistPerfBonusReportParams {
    reportBy?: string;
    beginningPeriodNo?: string;
    endingPeriodNo?: string;
    mgrNo?: string;
    clNo?: string;
    includeDayRate?: boolean;
}

interface IHistPerfBonusDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onGenerateReport: (params: IHistPerfBonusReportParams) => void;
    defaultPeriodNo?: number;
    // Owned by the parent, populated once the parent has actually tried the report call
    // (e.g. no commission records matched the filters).
    message?: string;
}

const labelStyle: React.CSSProperties = { whiteSpace: 'nowrap' };

// Mirrors the "Hist. Perf. Bonus" button (B_HIST_PB) -> Expense_Params/Range_Parms -> PAY_COMMRPT_V3.RDF
// (Report By = Standard) / PAY_COMMPROS_V3.RDF (Report By = Prospect), ported as
// PerformanceBonusReport.rdl / ProspectPerformanceBonusReport.rdl respectively. Beginning/Ending
// Period default to the currently selected pay period, matching oid 66's own default (a single
// computed commission period), but both stay independently editable since the underlying report
// always supported a real period range.
const HistPerfBonusDialog = (props: IHistPerfBonusDialogProps) => {
    const { register, errors, getValues } = useForm();

    const handleOk = () => {
        const values = getValues();
        props.onGenerateReport({
            ...values,
            includeDayRate: !!values.includeDayRate,
        });
    };

    return (
        <Dialog title="Hist. Perf. Bonus" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '30%' }}>
            <RHFSelect
                label="Report By"
                labelStyle={labelStyle}
                name="reportBy"
                options={[
                    { value: 'M', label: 'Standard' },
                    { value: 'P', label: 'Prospect' },
                ]}
                defaultVal="M"
                register={register}
                errors={errors}
                labelOnLeft={true}
                style={{ width: '100%' }}
            />
            <div className="form-row">
                <RHFInputBox
                    label="Beginning Period"
                    labelStyle={labelStyle}
                    name="beginningPeriodNo"
                    type="number"
                    register={register}
                    errors={errors}
                    labelOnLeft={true}
                    spaceLabelContent={true}
                    style={{ width: '100%' }}
                    bodyStyle={{ width: '50%' }}
                    defaultVal={props.defaultPeriodNo !== undefined ? String(props.defaultPeriodNo) : undefined}
                />
                <RHFInputBox
                    label="Ending Period"
                    labelStyle={labelStyle}
                    name="endingPeriodNo"
                    type="number"
                    register={register}
                    errors={errors}
                    labelOnLeft={true}
                    spaceLabelContent={true}
                    style={{ width: '100%' }}
                    bodyStyle={{ width: '50%' }}
                    defaultVal={props.defaultPeriodNo !== undefined ? String(props.defaultPeriodNo) : undefined}
                />
            </div>
            <RHFInputBox
                label="Manager Number"
                labelStyle={labelStyle}
                name="mgrNo"
                type="number"
                register={register}
                errors={errors}
                labelOnLeft={true}
                spaceLabelContent={true}
                style={{ width: '100%' }}
                title="Blank = All Managers"
            />
            <RHFInputBox
                label="Client Number"
                labelStyle={labelStyle}
                name="clNo"
                type="number"
                register={register}
                errors={errors}
                labelOnLeft={true}
                spaceLabelContent={true}
                style={{ width: '100%' }}
                title="Blank = All Clients"
            />
            <RHFCheckbox label="Include Day Rate ?" labelStyle={labelStyle} name="includeDayRate" register={register} errors={errors} labelOnLeft={true} defaultChecked={true} />
            <div className="form-row" style={{ marginTop: '2rem', justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ width: '30%', marginRight: '1rem' }} text="OK" onClick={handleOk} />
                <Button className="blue-hover-button" style={{ width: '30%' }} text="Cancel" onClick={() => props.hideDialog()} />
            </div>
            <div style={{ marginTop: '1rem', minHeight: '1.2rem', textAlign: 'center', color: 'red' }}>{props.message}</div>
        </Dialog>
    );
};

export default HistPerfBonusDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/employeePayroll/HistPerfBonusDialog.tsx